<template>
  <div class="overlay">
    <div
      :class="`alert-box-${type}`"
      class="alert-box"
    >
      <div class="alert-box-icon hidden-xs">
        <font-awesome-icon
          :icon="icon"
          size="3x"
        />
      </div>
      <div class="alert-box-content">
        <h2
          v-if="title"
          v-text="title"
        />
        <!-- eslint-disable-next-line vue/no-v-html vue/max-attributes-per-line -->
        <div v-if="message" v-html="message" />
        <form
          v-if="dataFields"
          @submit.prevent="submitData()"
        >
          <div
            v-for="(field, index) in dataFields"
            :key="`field-${index}`"
            class="form-group"
          >
            <!--suppress JSUnresolvedVariable -->
            <component
              :is="`${field.type || text}Field`"
              :key="index"
              v-bind="field"
              @input="$set(formFields, field.name, $event)"
            />
            <span
              v-if="errors.has(field.name)"
              class="has-error"
              v-text="errors.first(field.name)"
            />
          </div>
          <div
            v-if="type !== 'confirm'"
            class="alert-box-buttons pull-right"
          >
            <a
              class="btn btn-apex-danger"
              @click.prevent="$emit('cancel')"
              @keypress.enter.prevent="$emit('cancel')"
              v-text="buttonText.cancel"
            />
            <button
              type="submit"
              class="btn btn-primary"
              v-text="buttonText.ok"
            />
          </div>
        </form>
        <div
          v-if="type === 'confirm'"
          class="alert-box-buttons pull-right"
        >
          <button
            class="btn btn-apex-danger"
            @click.prevent="$emit('cancel')"
            v-text="buttonText.cancel"
          />
          <button
            class="btn btn-primary"
            @click.prevent="$emit('confirm')"
            v-text="buttonText.ok"
          />
        </div>
        <div
          v-if="inArray(type, ['error', 'success', 'info']) && ! dataFields"
          class="alert-box-buttons pull-right"
        >
          <button
            class="btn btn-primary"
            @click.prevent="$emit('close')"
            v-text="buttonText.ok"
          />
        </div>
      </div>
      <!-- eslint-disable-next-line vuejs-accessibility/anchor-has-content -->
      <a
        v-if="!dataFields"
        class="alert-close-button"
        @click.prevent="$emit('close')"
        @keypress.enter.prevent="$emit('close')"
      >
        <font-awesome-icon icon="times" />
      </a>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import dateField from './field/date.vue';
import fileField from './field/file.vue';
import selectField from './field/select.vue';
import spanField from './field/span.vue';
import textField from './field/text.vue';
import passwordField from './field/password.vue';

export default {
  components: {
    dateField,
    fileField,
    selectField,
    spanField,
    textField,
    passwordField,
  },
  props: {
    type: {
      type: String,
      default: 'info',
    },
    message: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    dataFields: {
      type: Array,
      default() {
        return [];
      },
    },
    buttonText: {
      type: Object,
      default() {
        return {
          ok: 'Ok',
          cancel: 'Cancel',
        };
      },
    },
  },
  data() {
    return {
      formFields: {},
    };
  },
  computed: {
    icon() {
      const app = this;
      switch (app.type) {
        case 'error':
          return 'exclamation-triangle';
        case 'success':
          return 'check-circle';
        case 'confirm':
          return 'question-circle';
        default:
          return 'comment';
      }
    },
  },
  methods: {
    submitData() {
      const app = this;
      app.$validator.validateAll().then((result) => {
        if (result) {
          app.$emit('confirm', app.formFields);
        }
      });
    },
    inArray(needle, haystack) {
      return !!_.find(haystack, needle);
    },

  },
};
</script>

<style lang="scss" type="text/scss" scoped="scoped">
@import './resources/assets/sass/variables';

.alert-box {
  text-align: left;
  font-size: 1em;
  border-radius: $border-radius;
  background-color: $white;
  position: absolute;
  max-width: 80%;
  width: 900px;
  height: auto;
  max-height: 90%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .alert-box-icon {
    border-radius: $border-radius 0 0 $border-radius;
    background-color: $primary;
    color: $white;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100px;
    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  &.alert-box-error {
    .alert-box-icon {
      background-color: $red;
    }
  }
  &.alert-box-success {
    .alert-box-icon {
      background-color: $green;
    }
  }
  .alert-box-content {
    max-height: 500px;
    overflow-y: auto;
    margin: 20px 20px 20px 120px;
    h2 {
      margin: 0 0 5px;
      font-size: 1.2em;
      font-weight: 900;
      font-style: italic;
    }
    .alert-box-buttons, form {
      .btn {
        margin-bottom: 0!important;
      }
    }
  }
  .alert-close-button {
    position: absolute;
    top: 5px;
    right: 7px;
  }
}
</style>
